// 创建文件en/index.js
const French = {
    my: "Ma",
    today: "Aujourd'hui",
    this_week: "Cette semaine",
    this_month: "Ce mois-ci",
    last_month: "Le mois dernier",
    this_year: "Cette année",
    number_of_people: "Nombre de personnes",
    amount: "Montant",
    enter_username_id_to_search: "Entrer le nom d'utilisateur ID pour rechercher",
    team_list: "Liste d'équipe",
    registration_time: "Heure d'inscription",
    selling_face_value: "Valeur faciale de vente",
    click_for_details: "Cliquez pour plus de détails",
    "agent_login": "Connexion Agent",
    "Agent.Center": "Centre d'Agents",
    'SignOut': 'Se déconnecter',
    'Contact us': "Contactez-nous",
    'Download our app': "Téléchargez notre application",
    'Download it from': "URL de téléchargement",
    'About Us': "à propos de nous",
    'Gobuy USA was founded in 2012': "Gobuy USA a été fondée en 2012",
    'Customer service': "service client",
    'frequently asked question': "FAQ",
    'Return and exchange policy': "Politique de retour et d'échange",
    'Shipping and distribution': "Distribution et livraison",
    'Contact us by email': "Contactez-nous par email",
    'Privacy Policy and Terms of Use': "Politique de confidentialité et conditions d'utilisation",
    'Privacy Policy': "politique de confidentialité",
    'Terms of use': "conditions d'utilisation",
    'Upload credentials': "Télécharger les informations d'identification",
    'The withdrawal is being processed': "Retrait en cours",
    'Cause of failure': "Raison de l'échec",
    'Your shopping cart is still empty': "Votre panier est toujours vide",
    'Log in to view the items in your cart': "Connectez-vous pour voir les articles dans le panier",
    'Browse around': "Parcourir",
    'Account correlation': "Lié au compte",
    'Order management': "Gestion des commandes",
    'Payment method': "Mode de paiement",
    'Collection address': "Adresse de paiement",
    Category: "Classification",
    "MyCommission": "ma commission",
    "Gross income": "revenu total",
    "Direct commission": "commission directe",
    "Indirect commission": "commission indirecte",
    "Transfer to wallet": "Transfert vers le portefeuille",
    "Tip: The transfer amount must be greater than 10USDT": "Astuce : Le montant du transfert doit être supérieur à 10USDT",
    "transfer": "transfert",
    "commission": "commission",
    "Please enter": "Veuillez entrer",
    "Team Commission": "Commission d'équipe",

    'Old Password': "Ancien mot de passe",
    'Change password': "Changer le mot de passe",
    'Gobuy GIFT CARD': "Carte cadeau Gobuy",
    'High Priced Recycling': "Un recyclage à prix élevé",
    'Data': "date",
    'congratulations': "Félicitations",
    'Obtain': "obtenir",
    'ThankYouForParticipating': "Merci d'avoir participé",

    // navbar"",
    Home: "première page",
    Search: "recherche",
    ShoppingCart: "panier",
    Mine: "le mien",

    // 首页
    // 搜索
    EnterSearchContent: "Saisir le contenu de la recherche",
    'Recent searches': "Recherches récentes",
    'popular searches': "Recherches populaires",
    'Please search': "Veuillez saisir les mots-clés que vous souhaitez rechercher",
    'orderSearch': "Entrez le nom de la commande ou du produit pour rechercher",

    // 语言
    'Language selection': "Sélection de la langue",

    // menu
    Brand: "marque",
    Collect: "collecter",
    Manage: "gérer",
    Order: "Commande",
    Wallet: "portefeuille",
    BlindBox: "boîte aveugle",
    MenuGiftCard: "carte cadeau",
    // HotSale
    HotSale: "Les dernières nouveautés sont en vente...",
    // tabs"",
    TodaysOffer: "Plateforme Préférée",
    'Phone': "téléphone portable",
    'Smart Watch': "montre intelligente",
    'Smart bracelet': "bracelet intelligent",

    // gobuy
    'home.gobuy.title': "Des surprises vous attendent",
    'home.gobuy.periods': "boîte aveugle ronde",
    'home.gobuy.freeze': "Participez au compte à rebours",
    'home.gobuy.drawing': "Démarrer le compte à rebours",
    'home.gobuy.buy': "participer",
    'home.gobuy.isbuy': "Déjà participé",
    'home.gobuy.jackpot': "cagnotte",
    Purse: "portefeuille",
    Box: "boîte aveugle",
    'GetAPrize': "Obtenez des prix",
    Discount: "Rabais",
    when: "quand",
    points: "intégral",
    seconds: "Deuxième",
    // MessageBox
    'MessageBox.Tips': "indice",
    'MessageBox.Confirm': "confirmer",
    'MessageBox.Cancel': "Annuler",
    'MessageBox.buy.box': "Etes-vous sûr de vouloir acheter cette boîte aveugle ?",
    // Toast
    'succ': "succès",
    'err': "erreur",
    'box.succeeds': "Achat réussi",
    'box.frozen': "Déjà participé",
    'box.issue': "Une seule boîte aveugle peut être achetée par numéro",

    // 商品列表
    filter: "filtre",
    sales: "Volume des ventes",
    selfOP: "Auto-exploité",
    noMore: "pas plus",
    brand: "marque",
    confirm: "confirmer",
    reset: "réinitialiser",
    ComSor: "Tri complet",
    MostPop: "le plus populaire",
    HighLow: "Prix ​​du haut au bas",
    LowHigh: "Prix ​​de bas en haut",
    SalVol: "volume des ventes",
    NewArr: "Nouvel arrivage",

    // 购物车
    'cart.cart': "panier",
    'cart.edit': "modifier",
    'cart.done': "Finition",
    'home.cart.voucher': "Obtenez des coupons",
    'home.cart.outstock': "en rupture de stock",
    'home.cart.offshelf': "Retiré des étagères",
    'Only': "seulement",
    'left': "individuel",
    'Promotion': "Promotion",
    'cart.all': "Tout sélectionner",
    'cart.total': "total",
    'cart.delete': "supprimer",
    'cart.checkout': "L'addition, s'il vous plaît",

    // 我的
    'Direct': "direct",
    'Indirect': "indirect",
    'MyOrders': "ma commande",
    'ViewAll': "Voir tout",
    'Unpaid': "En attente de paiement",
    'ToShip': "En attente d'expédition",
    'ToReceive': "En attente de réception",
    'ToReview': "En attente d'évaluation",
    // 盲盒
    'MyBlindBox': "Liste des boîtes aveugles",
    'WaitingDraw': "En attendant le tirage au sort",
    'Opened': "Ouvert (réception/retour)",
    // 礼品卡
    'After sale': "Après-vente",
    'GiftCard': "Dossiers de recyclage",
    'RecycleGiftCard': "Recycler les cartes cadeaux",
    'Verifying': "vérifier",
    'Rebuying': "Rachat",
    'Repurchased': "En attente de paiement",
    'Paid': "Le paiement a été effectué",
    // 常用工具
    'CommonTools': "Outils communs",
    'MyWallet': "mon portefeuille",
    'VirtualOrders': "commande virtuelle",
    'Refunds': "Remboursement",
    'MyFriends': "mes amis",
    'ChatList': "liste de discussion",
    'RealNameVerification': "Authentification par nom réel",
    'MyFavorites': "ma collection",
    'Addresses': "Gestion des adresses",
    'MyReviews': "Mon avis",
    'BrowsingHistory': "Parcourir l'historique",
    'Promotions': "promos",
    'StoreManagement': "gestion du magasin",
    'BecomeASeller': "Devenez vendeur",

    // 订单列表
    'SearchPlaceholder': "Entrez le nom du produit de la commande à rechercher",
    All: "tous",
    OrderNo: "Numéro de commande",
    items: "pièces",
    ShippingFee: "fret",
    'Refund in Progress': "Remboursement en cours",
    'Cancel Order': "Annuler la commande",
    'Refund': "Remboursement",
    'Track Shipping': "vérifier la logistique",
    'Confirm Receipt': "confirmer la réception des marchandises",
    'Evaluate': "évaluer",
    'Delete': "supprimer",
    'Pay': "Paiement",
    'MessageBox.delete.order': "Êtes-vous sûr de vouloir supprimer cette commande ?",
    'MessageBox.cancel.order': "Êtes-vous sûr de vouloir annuler cette commande ?",
    'MessageBox.receive.order': "Cette commande a-t-elle été reçue ?",
    // 订单详情
    'Order Details': "Détails de la commande",
    'Pickup Code': "Code de ramassage",
    'Complaint': "plainte",
    'After-Sales': "Après-vente",
    'Gift': "Cadeau",
    'Order Date': "date de commande",
    'Used voucher worth': "Montant du bon utilisé",
    'CNY': "RMB",
    'Payment Method': "Mode de paiement",
    'Total Product Amount': "Montant total du produit",
    'Shipping Fee': "fret",
    'Amount Paid': "Montant payé",
    'Return': "retourner la marchandise",
    // 盲盒列表
    'Pending Draw': "En attente du tirage au sort",
    'Pending Unboxing': "A ouvrir",
    'Unboxed': "Déjà allumé",
    'Collected': "Reçu",
    'Recycled': "Recyclé",
    'Unknown': "inconnu",
    'Claim': "recevoir",
    'Recycle': "Rachat",
    'Unbox': "allumer",
    'MessageBox.recycle.box': "Etes-vous sûr de vouloir recycler cette boîte aveugle ?",
    // 盲盒详情
    'Mystery Box Details': "Détails de la boîte aveugle",
    'Unopened': "Pas allumé",
    'box.opened': "Pas allumé",
    'Claimed': "Reçu",
    'Confirm Claim': "Confirmer la collecte",
    'MessageBox.pick.box': "Êtes-vous sûr de vouloir extraire cette boîte aveugle ?",
    // 盲盒提货
    'Please add address': "Veuillez ajouter l'adresse",
    // 礼品卡列表
    'Face Value Total': "Valeur nominale totale",
    // 礼品卡详情
    'Gift Card Details': "Détails de la carte cadeau",
    'Card number': "numéro de carte",
    'Activation code': "code d'activation",
    'Actual recovery price': "prix réel du recyclage",
    // 礼品卡回收
    'Gift Card Recycling': "Recyclage des cartes cadeaux",
    'Confirm Recycling': "Confirmer le recyclage",
    'Please enter the card number': "Veuillez saisir le numéro de carte",
    'Please enter the activation code': "Veuillez entrer le code d'activation",
    'MessageBox.recycle.gift': "Etes-vous sûr de vouloir recycler cette carte cadeau ?",

    // 我的钱包
    'My Wallet': "mon portefeuille",
    'Available Balance': "solde disponible",
    'Gift Balance': "Solde Cadeau",
    'All': "Tous",
    'Next event loading': "Chargement de l'événement suivant",
    'Frozen Funds': "geler les fonds",
    'Recharge': "recharger",
    "can": "Peut",
    'Withdraw': "Retirer de l'argent",
    'Withdrawal Accounts': "Retirer le compte",
    // 充值
    'Recharge Details': "Détails de la recharge",
    'Recharge Order No.': "Numéro de commande de recharge",
    'Recharge Amount': "Montant de la recharge",
    'Creation Time': "temps de création",
    'MessageBox.recharge.pop': "Veuillez saisir le montant de la recharge",
    // 付款
    'payment': "Paiement",
    'Order submitted successfully, please select payment method': "Commande soumise avec succès, veuillez sélectionner le mode de paiement",
    'Rechargeable card': "carte rechargeable",
    'Please enter a hash': "Veuillez saisir le hachage",
    'Immediate payment': "Payez maintenant",
    'Wait for the file to load': "Veuillez attendre que le fichier se charge",
    // 提现
    'Withdrawal Details': "Détails du retrait",
    'Withdrawal Amount': "Montant du retrait",
    'Application Time': "Temps de candidature",
    'New Application': "nouvelle demande",
    'Payment Password': "Mot de passe de paiement",
    'New Payment Password': "Nouveau mot de passe de paiement",
    'Recipient Information': "Informations sur le bénéficiaire",
    'Submit': "soumettre",
    'Add Recipient Account First': "Veuillez d'abord ajouter un compte de paiement",
    'Please bind your mobile phone or email first': "Veuillez d'abord lier votre téléphone portable ou votre e-mail",
    // 设置
    'Account Settings': "Paramètres du compte",
    'Change Login Password': "Changer le mot de passe de connexion",
    'Change Payment Password': "Changer le mot de passe de paiement",
    'Log Out': "se déconnecter",
    'Mobile': "téléphone portable",
    'Verification Code': "Le code de vérification",
    'Email': "Mail",
    'New Password': "Nouveau mot de passe",
    'Confirm Password': "Confirmez le mot de passe",
    'Modify': "Réviser",
    'Bind': "obligatoire",
    ' Mobile': "téléphone portable",
    ' Email': "Mail",
    // 资金详情
    'Fund Details': "Détails du financement",
    'Withdrawal Account': "Retirer le compte",
    'Account Type': "Type de compte",
    'USDT Address (opBNB)': "USDT-opBNB",
    'Edit': "modifier",
    'Delete': "supprimer",
    'Add New': "Ajouter un nouveau compte",
    'MessageBox.delete.bank': "Êtes-vous sûr de vouloir supprimer ce compte de retrait ?",
    // 登录
    'Login': "Se connecter",
    'Sign Up': "registre",
    'Normal Login': "Connexion normale",
    'Username / Email / Phone Number': "Nom d'utilisateur/e-mail",
    'Enter Phone Number': "Veuillez entrer le numéro de téléphone portable",
    'Enter Email': "Veuillez saisir votre adresse e-mail",
    'Enter SMS Code': "Veuillez saisir le code de vérification SMS",
    'Enter Password': "Veuillez entrer le mot de passe",
    "enter_login_password_for_verification": "Veuillez entrer votre mot de passe de connexion pour la vérification",
    'Forgot Password': "oublier le mot de passe",
    'Third-party Login': "Connexion tierce",
    'Please complete the form': "Veuillez remplir le formulaire",
    'WeChat': "WeChat",
    'Weibo': "Weibo",
    'QQ': "QQ",
    'phone login': "Connexion mobile",
    'Login Expired': "La connexion a expiré",
    'Please enter your phone number first': "Veuillez d'abord entrer votre numéro de portable",
    'Please enter your username/email/phone number': "Veuillez entrer votre nom d'utilisateur/e-mail",
    'Please enter your password': "Veuillez entrer le mot de passe",
    'Password must be at least 6 characters': "Le mot de passe doit contenir au moins 6 caractères",
    'Please enter an 11-digit phone number': "Veuillez saisir votre numéro de téléphone portable à 11 chiffres",
    'Please wait for the file to finish loading': "Veuillez attendre que le fichier soit chargé",
    'send': "envoyer",
    'signUpTips': "Vos données personnelles seront utilisées pour améliorer votre expérience sur l'ensemble du site Web, gérer l'accès à votre compte et à d'autres fins décrites dans notre politique de confidentialité.",

    // 注册
    'Sign Up': "registre",
    'Referrer': "recommandateur",
    'Invitation code': "Code d'invitation",
    'Invite friends': "Inviter des amis",
    'Username': "nom d'utilisateur",
    'Full Name': "vrai nom",
    'Set Password': "Définir le mot de passe",
    'Confirm Password': "Confirmez le mot de passe",
    'Phone Number': "numéro de téléphone",
    'Email': "e-mail",
    'Username: 3-25 chars, letters & numbers': "Nom d'utilisateur : 3 à 25 caractères, lettres et chiffres",
    '6-20 digits/letters/symbols': "6-20 chiffres/lettres/symboles",
    'By clicking sign up, you agree to': "En cliquant pour vous inscrire, vous acceptez",
    'User Agreement': "Contrat d'utilisation",
    'Please check the user agreement': "Veuillez vérifier les conditions d'utilisation",
    'Please enter a username with 3-25 characters': "Veuillez saisir un nom d'utilisateur de 3 à 25 caractères",
    'Enter SMS Verification Code': "Veuillez saisir le code de vérification SMS",
    'Please enter your phone number': "Veuillez entrer votre numéro de portable",
    'Please enter the verification code': "Veuillez entrer le code de vérification",
    'Please enter a 6-digit verification code': "Veuillez saisir le code de vérification à 6 chiffres",
    'Please enter a password with 6-20 characters': "Veuillez saisir un mot de passe de 6 à 20 caractères",
    'Please enter the confirm password': "Veuillez saisir le mot de passe de confirmation",
    'The confirm password does not match the entered password': "Le mot de passe de confirmation ne correspond pas au mot de passe saisi",

    // 密码恢复
    'Password Recovery': "Récupération de mot de passe",
    'Forgot Password': "oublier le mot de passe",
    'Forget.email.tips': "Si votre compte n'est pas encore associé à un numéro de messagerie, veuillez contacter l'administrateur de la plateforme pour récupérer votre mot de passe.",

    // 通知
    'Notification Message': "message de notification",
    'Direct Message': "message privé",
    'System Message': "Messages système",
    'Leave a Message': "message",

    // 配送地址
    'Delivery Address': "adresse de livraison",
    'The store is no longer valid, please edit the delivery address again': "Cette boutique n'est plus valide, veuillez rééditer l'adresse de livraison",
    'Default address': "Adresse par défaut",
    'Add address': "Ajouter une adresse",
    'Edit address': "Modifier l'adresse",
    'MessageBox.delete.address': "Êtes-vous sûr de vouloir supprimer cette adresse ?",
    'name': "Nom",
    'phone': "Numéro de téléphone",
    'district': "district",
    'address': "adresse",
    'default address': "Adresse par défaut",
    'save and use': "Enregistrer et utiliser",
    'save': "sauvegarder",
    'Please select a region': "Veuillez sélectionner une région",
    'Please fill in the recipient name': "Veuillez saisir le nom du destinataire",
    'Name must be 2-15 characters': "Le nom doit comporter entre 2 et 15 caractères",
    'Please fill in the mobile phone number': "Veuillez entrer le numéro de téléphone portable",
    'Please select your location': "Veuillez sélectionner votre emplacement",
    'Please fill in the detailed address': "Veuillez remplir l'adresse détaillée",

    // 浏览历史
    'Browsing History': "Parcourir l'historique",
    'Clear browsing history': "Effacer l'historique de navigation",

    // 推广会员
    'Promotion member': "Promouvoir les membres",
    "PromotionPoster": "affiche promotionnelle",
    "MemberName": "Nom du membre",
    "MyAssets": "mes atouts",
    "DistributedAmount": "Montant distribué",
    "NumberOfDistributedProducts": "Attribuer la quantité de produit",
    "DistributedProductAmount": "Montant distribué",
    "MyTeam": "mon équipe",
    "LevelOneMembers": "membre de première classe",
    "LevelTwoMembers": "membre de deuxième niveau",
    "PromotionPoster": "affiche promotionnelle",
    "PromotionMembers": "Promouvoir les membres",
    "PromotionPerformance": "performances promotionnelles",
    "ViewPromotionLink": "Cliquez pour voir le lien de promotion",
    "PromoteViaWeChatQRCode": "Promouvoir via le code QR WeChat",
    "Copy": "copie",
    "BrowserNotSupportedCopyManually": "Votre navigateur ne prend pas en charge la copie directe, veuillez copier manuellement",
    "GiftCardRecoveryTotal": "Nombre total de cartes cadeaux recyclées",
    "TodaysGiftCardRecoveryCount": "Le décompte du recyclage des cartes-cadeaux du jour",
    "RegistrationDate": "Date d'inscription",
    "LastLogin": "dernière connexion",
    "Promotion Commission": "Commission promotionnelle",

    // userinfo 个人信息
    "Personal Info": "informations personnelles",
    "Nickname": "Surnom",
    "Birthdate": "date de naissance",
    "Save": "sauvegarder",
    "CropImage": "Recadrer l'image",
    "UseImage": "Utiliser des images",

    // goodsDetail 商品详情
    "Off": "Rabais",
    "Sold": "vendu",
    "Product": "produit",
    "Comment": "Commentaire",
    "Details": "Détails",
    "ReportViolation": "rapport",
    "Cart": "panier",
    "ChatMessages": "Messages de discussion",
    "MyShop": "mon magasin",
    "MerchantLogin": "Connexion marchand",
    "Share": "partager",
    "ShareTo": "Partager sur",
    "WeChat": "WeChat",
    "Copy": "copie",
    "Poster": "affiche",
    "BrowserNotSupportedCopyManually": "Votre navigateur ne prend pas en charge la copie directe, veuillez copier manuellement",
    "Follow": "se concentrer sur",
    "Unfollow": "Ne plus suivre",
    "PleaseSelectQuantityAndCategory": "Veuillez sélectionner la quantité et la catégorie.",
    "SelectedWithQuantity1": "{spécification} sélectionné, quantité {numéro}.",
    "SelectedQuantity1": "Quantité sélectionnée {numéro}.",
    "SelectedWithQuantity2": "{spécification} sélectionné, quantité {numéro}.",
    "Add to cart": "ajouter au panier",
    "Buy now": "Achetez-le maintenant",
    "Stock": "en stock",
    "Pieces": "pièces",
    "Quantity": "quantité",
    "All": "tous",
    "Good": "Bonnes critiques",
    "Medium": "Note neutre",
    "Bad": "Mauvaise critique",
    // 评论
    "Product review": "avis sur les produits",
    "anonymous": "anonyme",
    "noReviewInfo": "Aucune information de commentaire fournie",
    "Shop Owners Response": "Le commerçant répond",
    "This product has no current reviews": "Il n'y a actuellement aucun avis pour ce produit",
    "Product details": "Détails du produit",
    "shop": "boutique",
    "customerService": "service client",
    "shoppingCart": "panier",
    "addToCart": "ajouter au panier",
    "buyNow": "Achetez-le maintenant",
    "outOfStock": "Le produit sélectionné est actuellement en rupture de stock, désolé !",
    "notAvailable": "Le produit sélectionné n'est plus disponible, désolé !",
    "Store order message": "Nouvelles des commandes en magasin",
    "Confirm the order": "Confirmer la commande",
    "productAmount": "Quantité de produit",
    "discount": "Rabais",
    "shippingFee": "fret",
    "subtotal": "Sous-total du magasin",
    "Submit an order": "Soumettre la commande",
    // 退货
    "refundAdd": "Ajouter un remboursement",
    "back": "retour",
    "refundDescription": "Instructions de remboursement :",
    "proofOfRefund": "Bon de remboursement",
    "use": "utiliser",


    // 一元购
    "yi1": `Achat à un euro`,
    "yi2": `Zone de prix`,
    "yi3": `Zone`,
    "yi4": `Historique des achats`,
    "yi5": `Historique des produits obtenus`,
    "yi6": `Voir le code de remboursement`,
    "yi7": `Demander un retrait`,
    "yi8": `Recharger`,
    "yi9": `Quantité participée`,
    "yi10": `Quantité totale`,
    "yi11": `Quantité manquante`,
    "yi12": `Acheter maintenant`,
    "yi13": `Continuer à acheter`,
    "yi14": `Autres zones`,
    "yi15": `Charger plus`,
    "yi16": `À venir...`,
    "yi17": `Zone`,
    "yi18": `Tour`,
    "yi19": `Période`,
    "yi20": `Prix : `,
    "yi21": `Charger plus`,
    "yi22": `Paiement rapide - Informations sur le produit que vous souhaitez acheter`,
    "yi23": `Quantité à acheter`,
    "yi24": `(Plus vous achetez, plus vos chances d'obtenir le produit sont grandes !)`,
    "yi25": `Total : `,
    "yi26": `Paiement réussi`,
    "yi27": `Échec du paiement`,
    "yi28": `Raison : `,
    "yi29": `Résultats révélés`,
    "yi30": `Code d'achat chanceux`,
    "yi31": `Gagnant du produit`,
    "yi32": `Félicitations, vous avez remporté ce produit`,
    "yi33": `Heure de révélation : `,
    "yi34": `Heure d'achat : `,
    "yi35": `Nombre total acheté par le gagnant : `,
    "yi36": ` Code d'achat :`,
    "yi37": `Retrait`,
    "yi38": `Encaisser`,
    "yi39": `Précommande`,
    "yi40": `Acheter`,
    "yi41": `Historique des produits obtenus`,
    "yi42": `Date de gain : `,

    "hunt1": `code de rédemption`,
    "hunt2": `Chance au rendez-vous`,
    "hunt3": `Imparable`,
    "hunt4": `Code de remboursement`,
    "hunt5": `Code de remboursement : `,
    "hunt6": `Charger plus`,
    "hunt7": `Je veux échanger`,
    "hunt8": `Veuillez entrer le code de remboursement`,
    "hunt9": `Le prix d'échange est 10% inférieur au prix de vente`,
    "hunt10": `Liste des produits`,
    "hunt11": `Zone`,
    "hunt12": `Langue`,
    "hunt13": `Annonce`,
    "hunt14": `Navigation`,
    "hunt15": `Annonce officielle`,
    "hunt16": `Historique des trésors`,
    "hunt17": `Règles d'expédition`,
    "hunt18": `Explication des règles`,
    "hunt19": `Je veux échanger`,
    "hunt20": `Contactez-nous`,
    "hunt21": `E-mail`,
    "hunt22": `Règles de loterie`,
    "hunt23": `Aperçu des règles`,
    "hunt24": `1. Attribution des numéros : `,
    "hunt25": `Pour chaque paiement de 0,1 USDT, l'utilisateur reçoit un numéro chanceux, commençant par 000001 et attribué séquentiellement jusqu'à ce que le nombre cible de participants soit atteint (par exemple, 1000).`,
    "hunt26": `2. Conditions de loterie : `,
    "hunt27": `Lorsque le produit atteint le nombre cible de participants (par exemple, 1000), le processus de loterie commence.`,
    "hunt28": `3. Heure de la loterie : `,
    "hunt29": `Après la confirmation de la dernière commande, attendez le prochain horaire de blockchain se terminant par 05, 10, 15, 25, 30, 35, 40, 45, 50, 55 ou à l'heure pleine.`,
    "hunt30": `4. Calcul du numéro gagnant : `,
    "hunt31": `1. Extraire les chiffres purs du hash du bloc et calculer le modulo basé sur le total des participants :
                Numéro gagnant = (Chiffres purs du hash % Total des participants) + 1`,
    "hunt32": `2. Le résultat calculé correspond au numéro gagnant.`,
    "hunt33": `Phase de participation`,
    "hunt34": `Les utilisateurs obtiennent un numéro chanceux pour chaque paiement de 0,1 USDT.`,
    "hunt35": `Lorsque le produit atteint le nombre cible de participants, les nouvelles entrées sont arrêtées.`,
    "hunt36": `Phase de loterie`,
    "hunt37": `Enregistrez l'heure exacte de la dernière commande (par exemple, 15:47:23).`,
    "hunt38": `Attendez que le prochain bloc de blockchain soit généré avec une heure conforme :`,
    "hunt39": `Horaire de blockchain se terminant par 05, 10, 15, 25, 30, 35, 40, 45, 50, 55 ou à l'heure pleine (par exemple, 15:50:00).`,
    "hunt40": `Obtenez le hash du bloc correspondant aux conditions.`,
    "hunt41": `Phase de gain`,
    "hunt42": `Extraire les chiffres purs du hash du bloc.`,
    "hunt43": `Exemple de hash de bloc : 0000000000000000000a16b6f44536e521000000adbcf3f4b2ec018ffabcd123`,
    "hunt44": `Chiffres purs extraits : 16644536521000000342018123`,
    "hunt45": `Modulo Total des participants : `,
    "hunt46": `Numéro gagnant`,
    "hunt47": `= (Chiffres extraits % Total des participants) + 1 `,
    "hunt48": `Si les chiffres extraits sont 16644536521000000342018123, et que le total des participants est 1000 : `,
    "hunt49": `= (16644536521000000342018123 % 1000) + 1 = 123 + 1 = 124`,
    "hunt50": `Publication des résultats`,
    "hunt51": `La plateforme annonce le numéro gagnant et les informations correspondantes de l'utilisateur.`,
    "hunt52": `Fournit également le processus de calcul complet (heure de commande, hash du bloc utilisé, chiffres extraits et formule de calcul du numéro gagnant).`,
    "hunt53": `Avantages`,
    "hunt54": `1. Équité`,
    "hunt55": `L'utilisation de hash blockchain public garantit que les résultats de la loterie sont imprévisibles et inviolables.`,
    "hunt56": `2. Transparence`,
    "hunt57": `Les utilisateurs peuvent vérifier les valeurs de hash et le processus d'attribution des numéros.`,
    "hunt58": `3. Haute efficacité`,
    "hunt59": `Les résultats peuvent être déterminés rapidement en attendant le bloc approprié.`,
    "hunt60": `Détails de l'annonce`,
    "hunt61": `Montant de l'achat : `,
    "hunt62": `Articles`,
    "hunt63": `Cliquez pour voir les codes d'achat`,
    "hunt64": `Code d'achat : `,
    "hunt65": `Explication des règles`,
    "hunt66": `À propos des commandes`,
    "hunt67": `Pour garantir une réception rapide de vos produits, les commandes passées avant 16h00 seront expédiées le jour même via XX Courrier ou XX Courrier. Pour une livraison express, contactez le service client pour payer la différence pour XX Courrier. D'autres services de messagerie ne sont actuellement pas pris en charge.`,
    "hunt68": `À propos des factures`,
    "hunt69": `Tous les produits vendus peuvent être délivrés avec des factures électroniques. Vous pouvez contacter le service client via votre commande et fournir les informations pour la facture. En général, les factures seront délivrées sous 1 à 3 jours. Si cela tombe pendant des jours fériés, l'émission sera reportée.`,
    "hunt70": `Achat chanceux`,


    "new1": "Exemple",
    "new2": "Le produit nécessite la participation de 1000 personnes. L'heure de la dernière commande est 15:47:23.\nLe temps de bloc le plus récent correspondant à l'heure du tirage est 15:50:00",
    "new3": "La valeur du hachage du bloc est :",
    "new4": "Extraction des chiffres purs de la valeur du hachage :",
    "new5": "Calcul du numéro gagnant :",
    "new6": "Numéro gagnant",
    "new7": "Le numéro gagnant est 124, l'utilisateur correspondant est le gagnant.",
    "new8": `Échangé`,
    "new9": `Non échangé`,
    "new10": `Malheureusement, vous n'avez pas gagné`,
    "new11": `Félicitations`,
    "new12": `A remporté l'article de cette session`,
    "new13": `Échanger`,
    "new14": `Achat Chanceux`,
    "new15": `Article Récupéré`,

    "new16": "Êtes-vous sûr de vouloir récupérer les marchandises ?",
    "new17": "Êtes-vous sûr de vouloir échanger ?",
    "copyS": "Copie réussie",
    "copyE": "Échec de la copie",
    "new18": "Présentation des produits",
    "new19": "Page précédente",
    "new20": "Page suivante",
    "new21": "À",
    "new22": "Page",
    "new23": "Confirmer",
    "new24": "En attente du tirage",

    "tool1": "Accueil",
    "tool2": "Produits",
    "tool3": "Nouvelles",
    "tool4": "Historique",
    "tool5": "Expédition",
    "tool6": "Règles",
    "tool7": "Échanger",
    "tool8": "Contact",

    "new25": "Remboursement du produit",
    "new26": "Veuillez saisir votre nom d'utilisateur gobuy",



    "ship1": "Champ d’application",
    "ship2": "Ces règles d’expédition s’appliquent à toutes les commandes sur la plateforme e-commerce luckybuy. Étant donné que la plateforme n’accepte que les paiements en USDT, elle ne prend pas en charge les paiements par carte de crédit, en espèces ou les déductions de fret. Les règles suivantes sont donc établies.",
    "ship3": "1. Règles d’expédition aux États-Unis",
    "ship4": "Modes de paiement",
    "ship5": "Seul le paiement en USDT est accepté. Les paiements par carte de crédit et en espèces ne sont pas pris en charge.",
    "ship6": "Service de paiement à la livraison",
    "ship7": "Le service de paiement à la livraison n’est disponible que pour les clients aux États-Unis. Le prépaiement des frais de port n’est pas nécessaire.",
    "ship8": "Politique d’expédition",
    "ship9": "Le montant de la commande n’inclut pas les frais de port, qui doivent être payés séparément.",
    "ship10": "Zone de livraison",
    "ship11": "La livraison est assurée sur l’ensemble du territoire continental des États-Unis.",
    "ship12": "Avis au client",
    "ship13": "Après avoir passé une commande, les clients doivent s’assurer que leurs coordonnées sont exactes. Les marchandises doivent être signées par le client ou un représentant autorisé au moment de la réception.",
    "ship14": "2. Règles d’expédition en dehors des États-Unis",
    "ship15": "Seul le paiement en USDT est accepté. Les paiements par carte de crédit et en espèces ne sont pas pris en charge.",
    "ship16": "Les clients hors des États-Unis doivent effectuer un paiement supplémentaire pour les frais de port après avoir finalisé le paiement de la commande.",
    "ship17": "Une fois ce paiement supplémentaire effectué, la plateforme organisera l’expédition.",
    "ship18": "Politique de paiement à la livraison",
    "ship19": "Le service de paiement à la livraison n’est pas fourni. Les clients hors des États-Unis doivent régler les frais de port avant que la commande ne soit traitée.",
    "ship20": "Processus pour les frais de port supplémentaires",
    "ship21": "Après la commande, la plateforme calculera les frais de port en fonction de l’adresse du client et informera le client de payer le montant supplémentaire via USDT.",
    "ship22": "Une fois le paiement des frais de port effectué, la plateforme organisera l’expédition et fournira les informations de suivi logistique.",
    "ship23": "La livraison est assurée dans tous les pays du monde. Le délai de livraison spécifique dépend des conditions logistiques locales.",
    "ship24": "Les clients doivent s’assurer que l’adresse et les coordonnées sont exactes. Toute impossibilité de livraison due à des informations incorrectes sera de la responsabilité du client.",
    "ship25": "La plateforme n’est pas responsable des politiques douanières du pays de destination. Les clients doivent se renseigner sur le dédouanement et assumer les éventuels frais supplémentaires.",
    "ship26": "Remarques",
    "ship27": "1. Une fois la commande payée avec succès, elle ne peut pas être annulée ou remboursée. Il est conseillé aux clients de vérifier soigneusement les informations de la commande avant le paiement.",
    "ship28": "2. luckybuy n’est pas responsable des problèmes résultant d’une force majeure pendant le transport (tels que les catastrophes naturelles ou les changements de politique), mais fera de son mieux pour aider les clients à les résoudre.",
    "ship29": "3. Pour toute question, veuillez contacter le service clientèle de notre plateforme.",
    "ship30": "Merci de votre compréhension et de votre soutien !",
    "ship31": "luckybuy est dévoué à vous servir.",
    // 礼品卡相关
    'Original Price':'Prix d\'origine',
    'Actual Payment':'Paiement réel',
    'Balance':'Solde',
    'MessageBox.buy.card': 'Êtes-vous sûr d\'acheter cette carte cadeau ?',
    'MyCard':'Ma Carte',
    'Please upload pictures':'Veuillez télécharger des images',
    'Share audit list':'Partager la liste de vérification',
    'Share page':'Partager la page',
    'Audit result':'Résultat de l\'audit',
    'Share to the community':'Partager avec la communauté',
    'imshares1':'Introduction des étapes',
    'imshares2':'Étape 1 : Partagez le produit sur les réseaux sociaux.',
    'imshares3':"Étape 2 : Prenez une capture d'écran de la page partagée du produit et téléchargez-la sur GoBuy.",
    'Share Time':'Heure de partage',
    'Audit status':'Statut de l\'audit',
    'Reason for failure':'Raison de l\'échec',
    'Pending approval':'En attente d\'approbation',
    'Approved':'Approuvé',
    'Audit failed':'Échec de l\'audit',
    'Url Copied': 'Lien copié avec succès, redirection vers le partage en cours...',
    "Points Logs": "Historique des points",
    "My Points": "Mes points",
    "Go Excharge": "Aller échanger",
    "Confirm points excharge": "Êtes-vous sûr de vouloir convertir tous les points en solde ?",
    'is not share': 'Vous n\'avez pas encore terminé la tâche de partage',
    'is buied': 'Vous avez déjà effectué un achat aujourd\'hui',
    'My card': 'Ma carte',
    "Country/Region": "Pays/Région",
    "Contact info": "Informations de contact",
    "Please enter real name": "Veuillez entrer le vrai nom",
    "Please enter Phone Number": "Veuillez entrer le numéro de téléphone",
    "Please enter State/Province/Region": "Veuillez entrer l'État/Province/Région",
    "Please enter City": "Veuillez entrer la ville",
    "Please enter Street Address": "Veuillez entrer l'adresse de la rue",
    "Please enter Postal Code": "Veuillez entrer le code postal",
    "lucky_draw_winning_products": "Produits gagnants du tirage au sort",
    "refundAdd": "Demande de remboursement",
    "refundDescription": "Description du remboursement",
    "productQualityIssue": "Problème de qualité du produit",
    "logisticsTransportIssue": "Problème de logistique et de transport",
    "sellerPlatformIssue": "Problème avec le vendeur ou la plateforme",
    "personalReason": "Raison personnelle",
    "otherSpecialCases": "Autres cas spéciaux",
    "hunt points rule": "Description des points",
    "hunt points rule1": "1. Obtention des points : Les utilisateurs obtiennent 1 point pour chaque 0.1 dollar investi dans l'achat chanceux",
    "hunt points rule2": "2. Échange de points : 1 points = 0.01% dollar",
    'Login Password': "Mot de passe de connexion",
    "Level": "Niveau",
    //新手指南
    "guide.Rewards": "Présentation des récompenses",
    "guide.title": "Guide du débutant",
    "guide.Invitation.Reward": "Récompense de l'événement",
    "guide.Order.Sharing": "Partage de commande",
    "guide.section1.title": "Guide d'achat chanceux",
    "guide.section1.step1": "Choisissez un achat : entrez dans la zone USD et sélectionnez votre article préféré.",
    "guide.section1.step2": "Choisissez la quantité : saisissez le nombre de parts auxquelles vous souhaitez participer.",
    "guide.section1.step3": "Quantité d'achat : seulement 0,1 $ pour acheter une unité.",
    "guide.section1.step4": "Attendez le tirage : le système sélectionne automatiquement le gagnant chanceux.",
    "guide.section2.title": "Guide d'achat de boîte mystère",
    "guide.section2.step1": "Ouvrez la boîte mystère : cliquez pour entrer dans la zone de boîte mystère.",
    "guide.section2.step2": "Participez maintenant : payez 10 USD.",
    "guide.section2.step3": "Révélez le prix : gagnez des prix d'une valeur allant jusqu'à 3 millions de dollars.",
    "guide.section3.title": "Guide d'achat de carte-cadeau",
    "guide.section3.step1": "Partagez la communauté : partagez immédiatement l'événement et téléchargez les informations.",
    "guide.section3.step2": "Choisissez la dénomination : sélectionnez librement le prix de la carte-cadeau.",
    "guide.section3.step3": "Achetez 100 cartes-cadeaux pour seulement 98 $.",
    "guide.section3.step4": "Rachat immédiat : 100 % de rachat, gagnez 2 $",
    "guide.tip.title": "Conseil chaleureux : ne manquez pas les super avantages",
    "guide.tip.luckyBuy": "Participez avec seulement 0,1 USD pour avoir une chance de gagner des prix de 1 USD à 50 000 USD !",
    "guide.tip.luckyBuy1": "Récompense de commission d'équipe : invitez des amis à acheter et profitez jusqu'à 0,02 % de commission !",
    "guide.tip.luckyBuy2": "Échange de points : gagnez 1 point pour chaque achat chanceux, 1000 points = 0,1 USD !",
    "guide.tip.example": "Exemple :",
    "guide.tip.example1": "Vous invitez l'utilisateur A, A achète pour 1000 USD → vous obtenez 2 USD de commission.",
    "guide.tip.example11": "A invite l'utilisateur B, B achète pour 1000 USD → vous obtenez encore 1 USD de commission.",
    "guide.tip.boxTitle": "Loterie de boîte mystère",
    "guide.tip.box": "Participez une fois avec 10 USD, des prix d'une valeur allant jusqu'à 3 millions de dollars !",
    "guide.tip.cardTitle": "Carte-cadeau",
    "guide.tip.card": "Commission d'équipe : invitez des amis à acheter et profitez jusqu'à 0,04 % de commission !",
    "guide.tip.example2": "Lorsque vous invitez l’utilisateur A à acheter une carte cadeau de 100 $, vous recevez une commission de 0,4 $.",
    "guide.tip.example3": "A invite l’utilisateur B. Si B achète une carte cadeau de 100 $, vous recevez 0,2 $ supplémentaires de commission.",
    "guide.tip.callToAction": "Participez maintenant et commencez votre voyage de chance !",
    "guide.warning.title": "Rappel chaleureux",
    "guide.warning.rule1": "Quelles situations entraînent l'invalidation des commissions ?",
    "guide.warning.answer1": "L'utilisation de logiciels ou d'autres plateformes pour obtenir des commissions de manière malveillante entraînera la déduction de toutes les commissions et la suspension du compte une fois vérifiée.",
    "guide.warning.rule2": "Puis-je gagner une commission en m'invitant moi-même ?",
    "guide.warning.answer2": "Non. Nous effectuons des contrôles manuels, et toute tricherie vérifiée entraînera la déduction de toutes les commissions, la révocation des qualifications d'invitation et la suppression du compte.",
    "invite.title": "Les avantages arrivent | Invitez des amis et gagnez 4 grands prix !",
    "invite.reward1.title": "Récompense 1 : Invitez dans le groupe, gagnez facilement des USD + des cartes-cadeaux",
    "invite.reward1.item1": "Recevez des récompenses en paquet rouge pour chaque 10 nouveaux membres invités avec succès !",
    "invite.reward1.item2": "Recevez également une carte-cadeau de 1 USD",
    "invite.reward1.item3": "Plus vous invitez, plus vous gagnez ! Paquets rouges envoyés instantanément, cartes-cadeaux échangeables maintenant !",
    "invite.reward2.title": "Récompense 2 : Achat chanceux, gagnez des commissions facilement",
    "invite.reward2.item1": "Vous gagnez une commission chaque fois que vos amis participent aux activités d'achat chanceux !",
    "invite.reward2.item2": "Commission illimitée, plus ils achètent, plus vous gagnez !",
    "invite.reward3.title": "Récompense 3 : Cartes-cadeaux",
    "invite.reward3.item1": "Vous gagnez immédiatement une commission lorsque vos amis achètent une carte-cadeau !",
    "invite.reward3.item2": "Lien de partage sans coût, suivi automatique, opération super facile :",
    "invite.reward3.item3": "Envoyez le lien → L’ami commande → Attendez la réception !",
    "invite.callToAction": "Dépêchez-vous d'inviter vos amis à rejoindre le groupe, ramenez tous les avantages chez vous ! Jouons et gagnons ensemble !",
    "share.title": "Partage gagnant GoBuy pour gagner une carte-cadeau de 1 USD",
    "share.subtitle": "Titre du partage",
    "share.content1": "Merci à GoBuy Lucky Shopping pour la bonne chance. L’un de nos membres a fait un petit investissement aujourd’hui, a gagné des prix et a réussi à retirer ! ✨",
    "share.content2": "Maintenant c’est votre tour ! Partagez simplement votre expérience de gain pour obtenir une carte-cadeau GoBuy gratuite de 1 USD ! Ne ratez pas ça — simple, gratifiant et amusant !",
    "share.inviteLink": "Joignez votre code de lien d’invitation :",
    "share.stepsTitle": "Comment participer :",
    "share.step1": "Téléchargez la capture d’écran de votre achat/code de commande dans la zone d'achat chanceux",
    "share.step2": "Téléchargez la capture d’écran du message « Félicitations, vous avez gagné ! »",
    "share.step3": "Téléchargez la capture d’écran de votre demande de retrait et de la réussite de la transaction",
    "share.step4": "Après avoir complété les étapes ci-dessus, envoyez votre capture d’écran de partage sur les réseaux sociaux à l’équipe du service client pour vérification",
    "share.email": "Email du support client :",
    "share.footer": "Que la chance soit avec vous — continuez à jouer, continuez à gagner ! GoBuy — rendre le shopping amusant et gratifiant chaque jour !",
    "doubleBet.title": "Miracle des paris｜3 étapes simples, renversez la situation et gagnez de grands prix !",
    "doubleBet.step1": "Première étape : Choisissez la zone à 1 $, achetez 0,5 $, achetez 5 unités et arrêtez dès que vous gagnez.",
    "doubleBet.step2": "Si vous n'avez pas gagné, deuxième étape : choisissez la zone à 3 $, achetez 1,5 $, achetez 15 unités et arrêtez dès que vous gagnez.",
    "doubleBet.step3": "Si vous n'avez toujours pas gagné, troisième étape : choisissez la zone à 8 $, achetez 4 $, achetez 40 unités, félicitations pour la victoire.",
    "doubleBet.step4": "Après avoir gagné, vous pouvez couvrir les pertes des étapes précédentes et réaliser un bénéfice, puis recommencer à partir de la première étape.",
    "invite.reward4.title": "Récompense 4 : Avantages à durée limitée | Cadeaux exclusifs pour les nouveaux utilisateurs",
    "invite.reward4.step1": "Participez gratuitement à 1 achat chanceux",
    "invite.reward4.step2": "Activez gratuitement 1 loterie de boîte mystère",
    "invite.reward4.step3": "Complétez les tâches spécifiées et obtenez une récompense en espèces supplémentaire de 1 $",
    "reward.register.title": "Récompense d'inscription",
    "reward.register.point1": "Les nouveaux utilisateurs reçoivent une participation gratuite au Lucky Buy dès l'inscription.",
    "reward.register.point2": "Rejoignez le groupe après inscription pour participer à l'événement des enveloppes rouges.",
    "reward.task.title": "Récompense de mission",
    "reward.task.point1": "Connectez-vous en tant qu'invité et ouvrez une boîte mystère.",
    "reward.task.point2": "Effectuez les 3 expériences Lucky Buy suivantes (une fois par zone) :",
    "reward.task.subtask1": "Zone 1 $ : achetez pour 0,5 $",
    "reward.task.subtask2": "Zone 3 $ : achetez pour 1,5 $",
    "reward.task.subtask3": "Zone 8 $ : achetez pour 4 $",
    "reward.task.point3": "Terminez les deux tâches pour recevoir une récompense de 1 $ !",
    "reward.share.title": "Récompense de partage",
    "reward.share.desc": "Je viens de gagner une boîte surprise et un tirage au sort sur GoBuy !",
    "reward.share.desc3": "J'ai eu de la chance juste après mon inscription – incroyable !",
    "reward.share.desc4": "✨Partage une capture d’écran de ta victoire pour recevoir 1 $ de récompense.",
    "reward.share.desc1": "Invitez 10 amis et gagnez 1 $ après leur inscription. Invitez-en 1 000 pour obtenir 100 $ de récompense. Aucune limite : plus vous invitez, plus vous gagnez !",
    "reward.invite.title": "Récompense d'invitation",
    "reward.invite.desc": "Invitez avec succès 10 amis et terminez leur inscription.",
    "reward.share.desc2": "Terminez les tâches ci-dessus pour obtenir vos récompenses de partage et d’invitation !",
    "reward.invite.desc1": "Terminez les tâches ci-dessus pour recevoir votre récompense d'invitation !",
}
export default French
